<template>
  <div class="content-body" style="padding-top: 6rem">
    <div class="container-fluid">
      <div class="page-titles">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">Info</a></li>
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'Paper' }">Data Paper</router-link>
          </li>
          <li class="breadcrumb-item">
            <a href="javascript:void(0)">{{ currentRouteName }}</a>
          </li>
        </ol>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Form {{ currentRouteName }}</h4>
            </div>
            <div class="card-body">
              <div class="basic-form">
                <!-- BASIC INFO -->
                <div class="card-header2 mb-3">
                  <h4 class="card-title">Informasi Dasar</h4>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Nama Produk <span class="text-danger">*</span></label>
                  <div class="col-sm-9">
                    <input v-model="post.nm_produk" @input="generateSlug" type="text" class="form-control" placeholder="Nama Produk" />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Slug URL</label>
                  <div class="col-sm-9">
                    <input v-model="post.slug" type="text" class="form-control" placeholder="Slug URL" readonly />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Kategori <span class="text-danger">*</span></label>
                  <div class="col-sm-9">
                    <select v-model="post.id_sub_kategori" class="form-control">
                      <option :value="null">Pilih Kategori</option>
                      <option v-for="sub in kategoriList" :key="sub.id" :value="sub.id">
                        {{ sub.judul }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Brand <span class="text-danger">*</span></label>
                  <div class="col-sm-9">
                    <input v-model="post.nm_brands" type="text" class="form-control" placeholder="Nama Brand" />
                  </div>
                </div>

                <!-- THUMBNAIL & MEDIA -->
                <div class="card-header2 mt-5 mb-3">
                  <h4 class="card-title">Media</h4>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Thumbnail <span class="text-danger">*</span></label>
                  <div class="col-sm-9">
                    <div class="input-group">
                      <div class="custom-file">
                        <input @change="handleFileUpload" type="file" class="custom-file-input" />
                        <label class="custom-file-label">{{ post.image ? post.image.name : "Pilih file" }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Image Caption (Alt) <span class="text-danger">*</span></label>
                  <div class="col-sm-9">
                    <input v-model="post.alt_image" type="text" class="form-control" placeholder="Input Caption Image" />
                  </div>
                </div>

                <!-- CONTENT -->
                <div class="card-header2 mt-5 mb-3">
                  <h4 class="card-title">Konten</h4>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Detail Produk <span class="text-danger">*</span></label>
                  <textarea ref="detailProduk" class="form-control summernote" id="detail_produk" v-model="post.detail_produk" rows="3"></textarea>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">General Application <span class="text-danger">*</span></label>
                  <textarea ref="generalAplication" class="form-control summernote" id="general_aplication" v-model="post.general_aplication" rows="3"></textarea>
                </div>

                <!-- SPECIFICATION -->
                <div class="card-header2 mt-5 mb-3">
                  <h4 class="card-title">Spesifikasi</h4>
                </div>
                <div class="form-group row" v-for="field in specFields" :key="field.key">
                  <label class="col-sm-3 col-form-label">{{ field.label }} <span class="text-danger">*</span></label>
                  <div class="col-sm-9">
                    <input v-model="post[field.key]" type="text" class="form-control" :placeholder="field.label" />
                  </div>
                </div>

                <!-- COMPATIBILITY -->
                <div class="card-header2 mt-5 mb-3">
                  <h4 class="card-title">Kompatibilitas</h4>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Printing Press Compatibility <span class="text-danger">*</span></label>
                  <div class="col-sm-9">
                    <textarea v-model="post.printing_press_compatibility" class="form-control" rows="2"></textarea>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Finishing Compatibility <span class="text-danger">*</span></label>
                  <div class="col-sm-9">
                    <textarea v-model="post.finishing_compatibility" class="form-control" rows="2"></textarea>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Grain Direction <span class="text-danger">*</span></label>
                  <div class="col-sm-9">
                    <input v-model="post.grain_direction" type="text" class="form-control" />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Crack When Fold <span class="text-danger">*</span></label>
                  <div class="col-sm-9">
                    <input v-model="post.crack_when_fold" type="text" class="form-control" />
                  </div>
                </div>

                <!-- CERTIFICATION -->
                <div class="card-header2 mt-5 mb-3">
                  <h4 class="card-title">Sertifikasi</h4>
                </div>
                <div class="form-group row" v-for="cert in certFields" :key="cert.key">
                  <label class="col-sm-3 col-form-label">{{ cert.label }}</label>
                  <div class="col-sm-9">
                    <select v-model="post[cert.key]" class="form-control">
                      <option :value="true">Ya</option>
                      <option :value="false">Tidak</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">USP <span class="text-danger">*</span></label>
                  <div class="col-sm-9">
                    <textarea v-model="post.usp" class="form-control" rows="2" placeholder="Unique Selling Point"></textarea>
                  </div>
                </div>

                <!-- META SEO -->
                <div class="card-header2 mt-5 mb-3">
                  <h4 class="card-title">Meta SEO</h4>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Meta Title <span class="text-danger">*</span></label>
                  <div class="col-sm-9">
                    <input v-model="post.meta_title" type="text" class="form-control" placeholder="Input Meta Title" />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Meta Description <span class="text-danger">*</span></label>
                  <div class="col-sm-9">
                    <input v-model="post.meta_deskripsi" type="text" class="form-control" placeholder="Max. 160 Characters" />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Meta Content <span class="text-danger">*</span></label>
                  <div class="col-sm-9">
                    <input v-model="post.meta_content" type="text" class="form-control" placeholder="Input Meta Content" />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Meta Name <span class="text-danger">*</span></label>
                  <div class="col-sm-9">
                    <input v-model="post.meta_name" type="text" class="form-control" placeholder="Input Meta Name" />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Hashtag <span class="text-danger">*</span></label>
                  <div class="col-sm-9">
                    <input v-model="post.hashtag" type="text" class="form-control" placeholder="Input Hashtag" />
                  </div>
                </div>

                <!-- STATUS -->
                <div class="form-group row mt-4">
                  <label class="col-sm-3 col-form-label">Status</label>
                  <div class="col-sm-9">
                    <select v-model="post.is_publish" class="form-control">
                      <option value="true">Publish</option>
                      <option value="false">Unpublish</option>
                    </select>
                  </div>
                </div>

                <button type="button" @click="goBack" class="btn btn-warning btn-sm mr-1">Kembali</button>
                <button type="button" @click="submit" class="btn btn-primary btn-sm mr-1">Simpan</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref, nextTick } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import axiosInstance from "../../../axios";

export default {
  name: "Tambah paper",
  setup() {
    const store = useStore();
    const router = useRouter();
    const detailProduk = ref(null);
    const generalAplication = ref(null);
    const currentRouteName = computed(() => router.currentRoute.value.name);

    // Kategori induk paper (tetap, samakan pola Blog/Product). Hanya turunannya yang ditampilkan.
    const paper_KATEGORI_ID = 29;

    const post = ref({
      nm_produk: "",
      slug: "",
      id_kategori: paper_KATEGORI_ID,
      id_sub_kategori: null,
      nm_brands: "",
      image: null,
      alt_image: "",
      detail_produk: "",
      general_aplication: "",
      base_material: "",
      size: "",
      grammature: "",
      thickness: "",
      surface_texture: "",
      coating: "",
      color: "",
      whiteness: "",
      printing_press_compatibility: "",
      finishing_compatibility: "",
      grain_direction: "",
      crack_when_fold: "",
      indigo_certified: false,
      fsc_pefc_certified: false,
      food_grade: false,
      usp: "",
      meta_title: "",
      meta_deskripsi: "",
      meta_content: "",
      meta_name: "",
      hashtag: "",
      is_publish: "true",
      created_by: null,
    });

    const specFields = [
      { key: "base_material", label: "Base Material" },
      { key: "size", label: "Size" },
      { key: "grammature", label: "Grammature" },
      { key: "thickness", label: "Thickness" },
      { key: "surface_texture", label: "Surface Texture" },
      { key: "coating", label: "Coating" },
      { key: "color", label: "Color" },
      { key: "whiteness", label: "Whiteness" },
    ];

    const certFields = [
      { key: "indigo_certified", label: "Indigo Certified" },
      { key: "fsc_pefc_certified", label: "FSC / PEFC Certified" },
      { key: "food_grade", label: "Food Grade" },
    ];

    const kategoriList = ref([]);
    const token = computed(() => store.state.token);

    const handleAuthError = (error) => {
      Swal.fire({
        title: "Error",
        text: error.message,
        icon: "error",
        confirmButtonText: "OK",
      }).then(() => {
        store.dispatch("setAuth", false);
        store.dispatch("setToken", { token: null, expiry: null });
        localStorage.clear();
        window.location.href = "/";
      });
    };

    const fetchUser = async () => {
      try {
        const response = await axiosInstance.get("/user", {
          headers: { Authorization: `Bearer ${token.value}` },
        });
        if (response.status === 200) {
          post.value.created_by = response.data.id;
        } else {
          throw new Error("Failed to fetch user data");
        }
      } catch (error) {
        handleAuthError(error);
      }
    };

    // Muat turunan (sub-kategori) dari kategori paper saja ke dalam dropdown.
    const fetchKategori = async () => {
      try {
        const response = await axiosInstance.get(`/kat-sub/${paper_KATEGORI_ID}`, {
          headers: { Authorization: `Bearer ${token.value}` },
        });
        if (response.status === 200) {
          kategoriList.value = response.data.data;
        }
      } catch (error) {
        console.error("Error fetching kategori", error);
      }
    };

    const handleFileUpload = (event) => {
      const file = event.target.files[0];
      const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/svg+xml", "image/webp"];
      const maxSize = 2 * 1024 * 1024;

      if (!validTypes.includes(file.type)) {
        Swal.fire({
          title: "Invalid File Type",
          text: "Please select an image with format jpeg, jpg, png, svg, or webp.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }
      if (file.size > maxSize) {
        Swal.fire({
          title: "File Too Large",
          text: "Please select an image smaller than 2MB.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }
      post.value.image = file;
    };

    const goBack = () => {
      router.push({ name: "Paper" });
    };

    const generateSlug = () => {
      post.value.slug = post.value.nm_produk
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    };

    // Semua field di form Tambah paper wajib diisi.
    const requiredFields = [
      { key: "nm_produk", label: "Nama Produk" },
      { key: "id_sub_kategori", label: "Kategori" },
      { key: "nm_brands", label: "Brand" },
      { key: "alt_image", label: "Image Caption (Alt)" },
      { key: "detail_produk", label: "Detail Produk" },
      { key: "general_aplication", label: "General Application" },
      { key: "base_material", label: "Base Material" },
      { key: "size", label: "Size" },
      { key: "grammature", label: "Grammature" },
      { key: "thickness", label: "Thickness" },
      { key: "surface_texture", label: "Surface Texture" },
      { key: "coating", label: "Coating" },
      { key: "color", label: "Color" },
      { key: "whiteness", label: "Whiteness" },
      { key: "printing_press_compatibility", label: "Printing Press Compatibility" },
      { key: "finishing_compatibility", label: "Finishing Compatibility" },
      { key: "grain_direction", label: "Grain Direction" },
      { key: "crack_when_fold", label: "Crack When Fold" },
      { key: "usp", label: "USP" },
      { key: "meta_title", label: "Meta Title" },
      { key: "meta_deskripsi", label: "Meta Description" },
      { key: "meta_content", label: "Meta Content" },
      { key: "meta_name", label: "Meta Name" },
      { key: "hashtag", label: "Hashtag" },
    ];

    const isEmpty = (val) => {
      if (val === null || val === undefined) return true;
      // Buang tag HTML kosong dari editor (mis. <p><br></p>) sebelum cek
      const stripped = String(val).replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
      return stripped === "";
    };

    const submit = async () => {
      post.value.detail_produk = $("#detail_produk").summernote("code");
      post.value.general_aplication = $("#general_aplication").summernote("code");

      // Validasi: semua field wajib diisi
      const missing = requiredFields.filter((f) => isEmpty(post.value[f.key]));
      if (!post.value.image) missing.push({ key: "image", label: "Thumbnail" });
      if (missing.length) {
        Swal.fire({
          title: "Form belum lengkap",
          html: "Field berikut wajib diisi:<br><b>" + missing.map((f) => f.label).join(", ") + "</b>",
          icon: "warning",
          confirmButtonText: "OK",
        });
        return;
      }

      const formData = new FormData();
      Object.keys(post.value).forEach((key) => {
        if (key === "image") return;
        let value = post.value[key];

        // Konversi string "true"/"false" ke 1/0 untuk validasi boolean Laravel
        if (value === "true") value = 1;
        if (value === "false") value = 0;
        if (typeof value === 'boolean') {
           value = value ? 1 : 0;
        }

        if (value !== null && value !== undefined && value !== "") {
          formData.append(key, value);
        }
      });
      formData.append("updated_by", post.value.created_by);
      if (post.value.image) {
        formData.append("image", post.value.image);
      }

      try {
        const response = await axiosInstance.post("/paper", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token.value}`,
          },
        });

        if (response.status === 200) {
          if (response.data.success === false) {
            Swal.fire("Error", `Error: ${response.data.message}`, "error");
          } else {
            Swal.fire({
              title: "Success",
              text: "Data created successfully!",
              icon: "success",
              confirmButtonText: "OK",
            }).then(() => goBack());
          }
        } else {
          Swal.fire("Error", "Error creating data", "error");
        }
      } catch (error) {
        Swal.fire("Error", `Error: ${error.message}`, "error");
      }
    };

    onMounted(async () => {
      await fetchUser();
      await fetchKategori();
      await nextTick();
      $(".summernote").summernote({
        height: 200,
      });
    });

    return {
      currentRouteName,
      post,
      kategoriList,
      specFields,
      certFields,
      handleFileUpload,
      generateSlug,
      submit,
      goBack,
      detailProduk,
      generalAplication,
    };
  },
};
</script>
